import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import {
    getPromotionProviders,
    getBrandLevelPromoProvider,
    updateBrandLevelPromoProviderSettings,
    getRestaurantLevelPromoProvider,
    updateRestaurantLevelPromoProviderSettings,
    changeChainLevelPromotionSettings,
    updateBrand
} from '../../actions';
import StringTemplateRenderer from '../common/stringTemplateRenderer/StringTemplateRenderer';
import CrossComponentCheckbox from '../common/stringTemplateRenderer/CrossComponentCheckbox';

class PromotionProviders extends Component {
    constructor() {
        super();

        this.state = {
            selectedProvider: {
                type: {
                    id: -1,
                    value: null
                }
            },
            restaurantId: -1,
            crossComponentCheckbox: false
        }
    }

    componentDidMount() {

        this.props.getPromotionProviders();

        if (window.location.pathname.includes('/brand/')) {
            this.props.getBrandLevelPromoProvider(this.props.brand.id);
        } else {

            const restaurantId = window.location.pathname.split('/')[2];
            this.props.getRestaurantLevelPromoProvider(restaurantId);

            this.setState({
                ...this.state,
                restaurantId
            });
        }
    }

    componentDidUpdate(prevProps) {

        if (prevProps.promotionProviders.selectedPromoProvider !== this.props.promotionProviders.selectedPromoProvider) {

            this.setState({
                ...this.state,
                selectedProvider: this.props.promotionProviders.selectedPromoProvider,
                providerValue: this.props.promotionProviders.selectedPromoProvider.type.value,
                crossComponentCheckbox: this.props.brand.chainLevelPromotionSettings
            });
        }
    }

    renderForm() {

        const { avForm, stringTemplateContainer } = styles;

        return (
            <AvForm
                onValidSubmit={this.submit}
                style={avForm}>

                <div style={stringTemplateContainer}>
                    <StringTemplateRenderer
                        updateSettings={this.updateSettings}
                        selectedItem={this.state.selectedProvider} // Use state to ensure component rerender
                        items={this.props.promotionProviders.providers}
                        selectLabel={i18n.t('screens:promotionProvidersScreen.selectLabel')}
                        selectInputDefaultOption={i18n.t('screens:promotionProvidersScreen.selectInputDefaultOption')}
                        renderSelectSibling={window.location.pathname.includes('/brand/') &&
                            <CrossComponentCheckbox
                                checkboxLabel={i18n.t('screens:promotionProvidersScreen.checkboxLabel')}
                                onChange={() => this.changeCheckboxState()}
                                isChecked={this.state.crossComponentCheckbox}
                            />
                        }
                    />
                </div>

                <Button color="primary" sm={12}>
                    <MaterialIcon icon="save" color="#fff" size={18} />
                    <span style={{ paddingLeft: 4 }}>{i18n.t('common:buttons.save')}</span>
                </Button>
            </AvForm>
        );
    }

    updateSettings = (provider) => {

        this.setState({
            ...this.state,
            selectedProvider: provider
        });
    }

    changeCheckboxState() {

        this.setState({
            ...this.state,
            crossComponentCheckbox: !this.state.crossComponentCheckbox
        });
    }

    submit = () => {

        if (!window.location.pathname.includes('/brand/')) {

            this.props.updateRestaurantLevelPromoProviderSettings(this.state.restaurantId, this.state.selectedProvider);

            return;
        }

        if (this.state.crossComponentCheckbox !== this.props.brand.chainLevelPromotionSettings) {

            this.props.changeChainLevelPromotionSettings(this.props.updateBrand);
        }

        this.props.updateBrandLevelPromoProviderSettings(this.props.brand.id, this.state.selectedProvider);
    }

    renderMessages() {

        const { value } = this.props.promotionProviders.chainPromotionPartnerType;

        return (
            <h6 style={{ marginTop: 12 }}> {`${value} ${i18n.t('screens:promotionProvidersScreen.restLevelDisabledSelectionMessage')}`}</h6>
        );
    }

    render() {

        return (
            <Fragment>
                {this.props.promotionProviders.chainPromotionPartnerType != null && !this.props.isBrandScreen ? this.renderMessages() : this.renderForm()}
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        promotionProviders: state.promotionProviders,
        brand: state.brand
    }
}

export default connect(
    mapStateToProps,
    {
        getPromotionProviders,
        getBrandLevelPromoProvider,
        updateBrandLevelPromoProviderSettings,
        getRestaurantLevelPromoProvider,
        updateRestaurantLevelPromoProviderSettings,
        changeChainLevelPromotionSettings,
        updateBrand
    }
)(PromotionProviders);

const styles = {
    avForm: {
        display: 'flex',
        marginTop: 30,
        paddingBottom: 30
    },
    stringTemplateContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 80px)'
    }
};


// WEBPACK FOOTER //
// ./src/components/promotionProviders/PromotionProviders.js